import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=4afdcde4&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=4afdcde4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdcde4",
  null
  
)

export default component.exports